import { style } from '@vanilla-extract/css';

export const linkElement = style({
  selectors: {
    '&[data-underline="true"]:hover': {
      textDecoration: 'underline',
    },
    // override global style
    [`&,
      .typedream.content &`]: {
      textDecoration: 'none',
      color: 'var(--accent)',
    },
  },
});

export const actionButton = style({
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  cursor: 'pointer',
  textAlign: 'inherit',
});
